import React from "react";
import { Modal } from "newui/components/ui/Modal";
import FallbackImage from "newui/components/FallbackImage/FallbackImage";
import TextBoxHTML from "newui/components/TextBoxHTML";

interface CompanyDescriptionModalProps {
	name: string;
	bannerPath?: string | null;
	description: string | null;
	isOpen: boolean;
	logoPath?: string | null;
	onClose: () => void;
}

export const CompanyDescriptionModal: React.FC<CompanyDescriptionModalProps> = ({
	bannerPath,
	description,
	isOpen,
	logoPath,
	name,
	onClose,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title={<span className="flex items-center gap-2"><FallbackImage src={logoPath} alt={`${name} logo`} className="h-12 object-contain" /></span>}
			size="xl"
			modalType="standard"
			secondaryButton={{
				text: "Close",
				onClick: onClose,
			}}
			iconType="info"
			closeOnOverlayClick
			closeOnEsc
		>
			<div className="flex max-h-[60vh] flex-col gap-4 overflow-y-auto">
				{/* Banner */}
				{bannerPath && (
					<img
						src={bannerPath}
						alt={`${name} banner`}
						className="w-full rounded-lg h-44 object-contain sm:h-48"
					/>
				)}

				{/* Company Name */}
				{name && (
					<div className="text-2xl font-bold text-gray-900">
						{name}
					</div>
				)}

				{/* Full description */}
				{description && (
					<TextBoxHTML html={description} />
				)}
			</div>
		</Modal>
	);
};
